var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "grid" },
    _vm._l(_vm.lengths, function (length, key) {
      return _c(
        "a",
        { key: length.sku, staticClass: "col-sm-6 col-xl-3" },
        [
          _c("moulding-option", {
            attrs: {
              length: length,
              selected:
                _vm.lengthSelected && length.sku === _vm.lengthSelected.sku,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("change", length)
              },
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }